// === SAA:UI:INBOEDEL-PRICING ===
// Thin wrappers around core's Inboedel pricing helpers. Pull Dekkingen out of the workflow
// data (with `_uiState` fallback for legacy storage) and delegate the math to core, so this
// customer code stays in sync with the email template + summary card automatically.

import { computeInboedelSelectedTotal, computeInboedelNetPremium, type ProductNetPremium } from '@sluitstraat/core';

const readDekkingen = (data: any) =>
  data?.Supportsection?.Dekkingen || data?._uiState?.Dekkingen || {};

/**
 * Inboedel total = base (IP+CY+BI+mobile EC, floored as one unit) + each selected optional
 * coverage at its individually-floored badge value. Always equals the arithmetic sum of the
 * badges shown on the Inboedel screen. Glass (GP) is rated by the Midglas engine and rides
 * through core's normal per-section handling like any other coverage.
 */
export const computeInboedelTotalFromSections = (data: any, config: any): number =>
  computeInboedelSelectedTotal(data, config, readDekkingen(data));

/**
 * Inboedel net premium (ex-provision, before tax) for breakdown cards. Mirrors AVP's
 * `computeAvpNetPremium`: sum selected section BTPs at full precision, strip provision, floor
 * once on the displayed value and keep the precise value so `composePremiumBreakdown` can
 * derive tax + total without the per-section-floor drift that `netFromTotal(badge)` introduces.
 */
export const computeInboedelNetFromSections = (data: any, config: any): ProductNetPremium =>
  computeInboedelNetPremium(data, config, readDekkingen(data));
